'use client';

import { createContext, ReactNode, useContext, useMemo } from 'react';

interface ReadOnlyContextType {
  isReadOnly: boolean;
}

const ReadOnlyContext = createContext<ReadOnlyContextType>({ isReadOnly: false });

interface ReadOnlyProviderProps {
  children: ReactNode;
  readOnly?: boolean;
}

export function ReadOnlyProvider({ children, readOnly = false }: ReadOnlyProviderProps) {
  const value = useMemo(() => ({ isReadOnly: readOnly }), [readOnly]);
  return <ReadOnlyContext.Provider value={value}>{children}</ReadOnlyContext.Provider>;
}

export function useReadOnly(): boolean {
  return useContext(ReadOnlyContext).isReadOnly;
}
